import { fetchAuthSession } from 'aws-amplify/auth';
import { S3Client, GetObjectCommand } from '@aws-sdk/client-s3';
import config from 'src/config';

export const downloadFromS3 = async (s3Key: string) => {
  const bucketName = config.productsBucketName;
  const fileName = s3Key.split('/').pop() ?? 's3-download';

  try {
    const { credentials } = await fetchAuthSession();
    if (!credentials) {
      throw new Error('No credentials available');
    }

    const s3Client = new S3Client({
      region: config.region,
      credentials,
    });

    const response = await s3Client.send(new GetObjectCommand({
      Bucket: bucketName,
      Key: s3Key,
    }));

    const stream = response.Body as ReadableStream;
    const reader = stream.getReader();
    const chunks = [];

    // Prepend BOM sequence to enable UTF (https://stackoverflow.com/a/61670918)
    const BOM = new Uint8Array([0xEF, 0xBB, 0xBF]);
    chunks.push(BOM);

    let result = await reader.read();
    while (!result.done) {
      chunks.push(result.value);
      result = await reader.read();
    }

    const blob = new Blob(chunks, { type: 'text/csv;charset=utf-8' });
    const downloadUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error('S3 download failed:', error);
  }

  return { bucketName, path: s3Key, fileName };
};
